/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { Add } from "@mui/icons-material";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getBlocksCristales } from "../../services/BlockCristalService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigo: "",
  descripcion: "",
  idBlProducto: null,
  idBlCrAdicion: null,
  idBlCurva: null,
  idBlEspesor: null,
  idOjo: null,
  codigoExterno: "",
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const ojoOptions = [
  {
    id: "izquierdo",
    label: "IZQUIERDO"
  },
  {
    id: "derecho",
    label: "DERECHO"
  },
  {
    id: "indistinto",
    label: "INDISTINTO"
  },
];

const nameItemsText = "Blocks-Cristales";
//
// #############################################################################
//
const BlockCristalTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openSolucionLimpiezaPuntoPedidoDialog, setOpenSolucionLimpiezaPuntoPedidoDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [blCrAdiciones, setBlCrAdiciones] = useState([]);
  const [blCurvas, setBlCurvas] = useState([]);
  const [blEspesores, setBlEspesores] = useState([]);
  const [blProductos, setBlProductos] = useState([]);
  const navigate = useNavigate();
  const [valueACBlProducto, setValueACBlProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputvalueACBlProducto, setInputvalueACBlProducto] = useState("");
  const [valueACBlCrAdicion, setValueACBlCrAdicion] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCrAdicion, setInputValueACBlCrAdicion] = useState("");
  const [valueACBlCurva, setValueACBlCurva] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlCurva, setInputValueACBlCurva] = useState("");
  const [valueACBlEspesor, setValueACBlEspesor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBlEspesor, setInputValueACBlEspesor] = useState("");
  const [valueACOjo, setValueACOjo] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACOjo, setInputValueACOjo] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearBlockCristal = hasPermission("block-cristal-c");
  const _editarBlockCristal = hasPermission("block-cristal-e");
  const _habilitarBlockCristal = hasPermission("block-cristal-h");
  const _deshabilitarBlockCristal = hasPermission("block-cristal-d");

  const tableColumns = [
    {
      field: "descripcion_block_producto",
      headerName: "Producto",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_block_producto;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "valor_bl_cr_adicion",
      headerName: "Adición",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.valor_bl_cr_adicion;
        _val = _val ? _val.toFixed(0) : "0";
        return _val;
      },
    },
    {
      field: "valor_bl_curva",
      headerName: "Curva",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.valor_bl_curva;
        _val = _val ? _val.toFixed(0) : "0";
        return _val;
      },
    },
    {
      field: "valor_bl_espesor",
      headerName: "Espesor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.valor_bl_espesor;
        _val = _val ? _val.toFixed(0) : "0";
        return _val;
      },
    },
    {
      field: "ojo",
      headerName: "Ojo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarBlockCristal && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarBlockCristal && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarBlockCristal && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    ////loading: isDoingSomething,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadBlCrAdiciones();
    loadBlCurvas();
    loadBlEspesores();
    loadBlProductos();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACBlProducto({
      id: "",
      descripcion: "",
    });
    setInputvalueACBlProducto("");
    setValueACBlCrAdicion({
      id: "",
      descripcion: "",
    });
    setInputValueACBlCrAdicion("");
    setValueACBlCurva({
      id: "",
      descripcion: "",
    });
    setInputValueACBlCurva("");
    setValueACBlEspesor({
      id: "",
      descripcion: "",
    });
    setInputValueACBlEspesor("");
    setValueACOjo({
      id: "",
      descripcion: "",
    });
    setInputValueACOjo("");
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      idBlProducto: searchData.idBlProducto,
      idBlCrAdicion: searchData.idBlCrAdicion,
      idBlCurva: searchData.idBlCurva,
      idBlEspesor: searchData.idBlEspesor,
      idOjo: searchData.idOjo,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };
    setIsDoingSomething(true);
    const response = await getBlocksCristales(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    if (action !== "new") {
      let _aditionalData = {
        codigo: itemCrud.codigo,
        estado: itemCrud.estado,
      };
      navigate("/bl-cristal/" + itemCrud.id + "/" + action, { state: _aditionalData });
    } else {
      navigate("/bl-cristal/" + action);
    }
  };
  //
  // ################################################################################
  // 
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrAdiciones = async () => {
    const response = await getCacheData("bl_cr_adicion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCrAdiciones(_var);
    } else {
      setBlCrAdiciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCurvas = async () => {
    const response = await getCacheData("bl_curva");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setBlCurvas(_var);
    } else {
      setBlCurvas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlEspesores = async () => {
    const response = await getCacheData("bl_espesor");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(0),
        });
      });
      setBlEspesores(_var);
    } else {
      setBlEspesores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlProductos = async () => {
    const response = await getCacheData("block_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlProductos(_var);
    } else {
      setBlProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-bl-producto"
                  size="small"
                  value={
                    valueACBlProducto && valueACBlProducto.id
                      ? valueACBlProducto
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlProducto(newValue);
                    setSearchData({
                      ...searchData,
                      idBlProducto: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputvalueACBlProducto}
                  onInputChange={(event, newInputValue) => {
                    setInputvalueACBlProducto(newInputValue);
                  }}
                  options={blProductos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-bl-cr-adicion"
                  size="small"
                  value={
                    valueACBlCrAdicion && valueACBlCrAdicion.id
                      ? valueACBlCrAdicion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCrAdicion(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCrAdicion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCrAdicion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCrAdicion(newInputValue);
                  }}
                  options={blCrAdiciones}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Adición" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-bl-curva"
                  size="small"
                  value={
                    valueACBlCurva && valueACBlCurva.id
                      ? valueACBlCurva
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlCurva(newValue);
                    setSearchData({
                      ...searchData,
                      idBlCurva: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlCurva}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlCurva(newInputValue);
                  }}
                  options={blCurvas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Curva" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-bl-espesor"
                  size="small"
                  value={
                    valueACBlEspesor && valueACBlEspesor.id
                      ? valueACBlEspesor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACBlEspesor(newValue);
                    setSearchData({
                      ...searchData,
                      idBlEspesor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACBlEspesor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACBlEspesor(newInputValue);
                  }}
                  options={blEspesores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Espesor" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ojo"
                  size="small"
                  value={
                    valueACOjo && valueACOjo.id ? valueACOjo : null
                  }
                  onChange={(event, newValue) => {
                    setValueACOjo(newValue);
                    setSearchData({
                      ...searchData,
                      idOjo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACOjo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACOjo(newInputValue);
                  }}
                  options={ojoOptions}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Seleccione Ojo " />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                  disabled={actionCrud === "view" || actionCrud === "delete"}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="id-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearBlockCristal && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo block-cristal">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlockCristalTable;
